import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasicModal from 'components/Modals/presets/BasicModal';
import Automation2Service from 'services/Automation2Service';
import { StyledNotice } from './styled';
import { useAutomationsDispatch } from '../store/react';
import { actions } from '../store';
import { toastVariant } from 'components/ToastProvider';
import Select from 'components/Inputs/Select';

export const ProcessingPriorityModal = ({
  automation,
  onConfirm,
  onHide,
  show,
}) => {
  const { t } = useTranslation();
  const [priority, setPriority] = useState(automation.priorityRank.toString());

  const dispatch = useAutomationsDispatch();

  const handleConfirm = async () => {
    try {
      const updatedAutomation = await Automation2Service.update({
        id: automation.id,
        priorityRank: parseInt(priority),
        lastRevision: automation.revision,
      });
      dispatch(
        actions.toast({
          variant: toastVariant.SUCCESS,
          message: t('Processing Priority Updated'),
        })
      );
      onConfirm(updatedAutomation);
    } catch (error) {
      dispatch(
        actions.toast({
          variant: toastVariant.FAILURE,
          message: t('Processing Priority Update Failed'),
        })
      );
    }
  };

  const handleChange = ({ value }) => {
    setPriority(value);
  };

  const options = useMemo(
    () => [
      { value: '10', label: t('Standard Processing') },
      { value: '20', label: t('Data Seeding (Lower Priority)') },
    ],
    [t]
  );

  return (
    <BasicModal
      heading={t('Processing Priority')}
      onConfirm={handleConfirm}
      onHide={onHide}
      show={show}
    >
      <StyledNotice>
        {t(
          'Data Seeding priority should be used for operations that should not block more time-sensitive automations.'
        )}
      </StyledNotice>
      <Select
        value={priority}
        onChange={handleChange}
        options={options}
        menuInline
      />
    </BasicModal>
  );
};
